export default function checkIfCanCreateSuggestionRoutes({ next, store }) {
  let scopes = store.getters.userScopes;
  return scopes.includes('suggestions_create') ? next() : next({ name: 'dashboard' });
}
